"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Branch = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_ui_1 = require("@yanzi/react-ui");
const react_1 = require("react");
const Chevron_1 = require("./Chevron");
function Branch({ children, label, selected, onClickLabel, isExpandable = true, shouldShowChevron = true, }) {
    const ref = react_1.useRef(null);
    const depth = react_1.useContext(DepthContext);
    const [expanded, setExpanded] = react_1.useState(depth < 1);
    react_1.useEffect(() => {
        if (selected && ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    }, [selected]);
    return (jsx_runtime_1.jsx(DepthContext.Provider, Object.assign({ value: depth + 1 }, { children: jsx_runtime_1.jsxs(react_ui_1.Box, { children: [jsx_runtime_1.jsxs(react_ui_1.Box, Object.assign({ p: 0, width: "100%", textAlign: "left", display: "flex", borderRadius: 3, ref: ref }, { children: [shouldShowChevron && (jsx_runtime_1.jsx(Chevron_1.Chevron, { expanded: expanded, hidden: !children || !isExpandable, onClick: () => setExpanded(old => !old) }, void 0)),
                        jsx_runtime_1.jsx(react_ui_1.Button, Object.assign({ display: "block", width: "100%", textAlign: "left", px: 2, py: 1, borderRadius: 3, fontWeight: 300, onClick: onClickLabel, backgroundColor: selected ? 'accent' : 'transparent', color: selected ? 'accentBackgroundedText' : 'inherit' }, { children: label }), void 0)] }), void 0),
                children && expanded ? jsx_runtime_1.jsx(react_ui_1.Box, Object.assign({ ml: "1.5rem" }, { children: children }), void 0) : jsx_runtime_1.jsx(react_ui_1.Box, {}, void 0)] }, void 0) }), void 0));
}
exports.Branch = Branch;
const DepthContext = react_1.createContext(0);
//# sourceMappingURL=Branch.js.map